import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://7363e15f8525ce71aa5f16fc82fe46c3@o4504287874580480.ingest.us.sentry.io/4511344947036160',
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});
